module.exports = __webpack_public_path__ + "static/media/7_C.84d7db10.png";